module.exports = __webpack_public_path__ + "assets/img/button.cabd3581.png";